export const APP_CONSTANTS = {
    appStore: {
        default: 'df',
        credentials: 'cr',
        app_console: 'fc',
        app_settings: 'fs',
        app_shows: 'fh',
        app_crosswords: 'fg',
        app_app: 'fr',
        app_comments: 'ac',
    },
    WATCH_HISTORY_DAYS: 30,
    CHOOSE_DISPLAY_LANGUAGE_DUO_STORAGE_KEY: 'cdldcode',
    APOLLO_STATE_META_NAME: '__APOLLO_STATE__',
    cookies: {
        COOKIE_SIGNED_IN: {
            key: 'csi',
            value_true: 'true',
            value_false: 'false',
        },
    },
};
//# sourceMappingURL=constants.js.map